import styled from 'styled-components';
import { RGBA_COLORS } from '../../../utils/colors';
import { HEADER_HEIGHT } from '../../../utils/consts';

export const WrapperS = styled.div`
  display: inline-flex;
  position: relative;
  flex-direction: column;
  background: ${RGBA_COLORS.getDefault(0.05)};
  margin-bottom: 5px;
  padding: 10px;
  width: 80%;
`;

export const WrapperBtnS = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  span {
    font-size: 10px;
    opacity: 0.7;
    margin-right: 5px;
  }
  button {
    padding: 0;
  }
`;

export const WrapperImageS = styled.div<{
  isLector?: boolean;
  isAdmin?: boolean;
  isMy?: boolean;
}>`
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  ${({ isLector }) =>
    isLector
      ? `background: #7DB945;
          color: white;`
      : ``}
  ${({ isMy }) => (isMy ? `background: rgba(26,130,197,0.1);` : ``)}
  ${({ isAdmin }) => (isAdmin ? `background: white;` : ``)}
`;

export const LogoWrapperS = styled.div`
  color: white;
  text-transform: uppercase;
  height: ${HEADER_HEIGHT};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 40px;
    height: 40px;
    transform: scale(0.6);
    transition: 0.2s;
  }
`;

export const NameWrapperS = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
`;
export const NameS = styled.span`
  color: ${RGBA_COLORS.getDefault(0.8)};
  font-weight: 500;
`;
export const TimeS = styled.span`
  color: ${RGBA_COLORS.getDefault(1)};
  opacity: 0.5;
  font-size: 10px;
  padding-left: 20px;
`;
export const MessageS = styled.div`
  font-size: 13px;
  margin-top: 5px;
  white-space: pre-line;
  word-break: break-word;

  a {
    color: ${RGBA_COLORS.getAccent()};
    text-decoration: underline;
    &:hover {
      // color: ${RGBA_COLORS.getAccent(0.7)};
      color: black;
    }
  }

  img {
    max-width: 240px !important;
    height: auto;
  }
`;

export const ReplyHeaderS = styled.div`
  display: flex;
  align-items: center;

  ${NameS} {
    font-size: 12px;
    font-weight: 500;
    color: black !important;
  }
`;
export const IconS = styled.span`
  display: block;
  transform: rotate(180deg);
  margin-right: 10px;
  i {
    color: black !important;
  }
`;
export const ReplyTextS = styled.p`
  margin: 5px 0;
  font-size: 11px;
  padding-left: 28px;
  font-weight: 300;
  color: black !important;
  word-break: break-word;
  * {
    color: black !important;
  }
  img {
    max-width: 220px !important;
    height: auto;
  }
`;

export const BtnCloseS = styled.button`
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 18px;
`;

export const ReplyWrapperS = styled.div`
  background: #f5f5f5;
  /* background: rgba(0, 0, 0, 0.2); */
  padding: 5px 10px;
  margin-top: 10px;

  ${WrapperS} {
    background: ${RGBA_COLORS.getAccent(1)};

    * {
      color: ${RGBA_COLORS.getDefault()} !important;
    }
  }
`;

export const MainWrapperS = styled.div<{
  isPinned?: boolean;
  isMy?: boolean;
  isAdmin?: boolean;
  isLector?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  ${({ isPinned }) =>
    isPinned
      ? `
    border: 1px solid ${RGBA_COLORS.getAccent()};
    padding: 5px 32px 5px 5px;
    background: white;
    left: 10px;
    top: 50px;
    position: absolute;
    width: calc(100% - 20px);
    max-height: 200px;
    overflow: auto;
    margin-bottom: 10px;
    z-index: 9;
    box-shadow: 0 10px 5px rgba(0, 0, 0, 0.1);
    ${WrapperS} {
      width: 100%;
      margin-bottom: 0;
    }
  `
      : ``}

  ${({ isMy }) =>
    isMy
      ? `
justify-content: flex-end;

${WrapperS} {
  background: ${RGBA_COLORS.getAccent(0.1)};
}

${TimeS} {
  padding-left: 0;
}
`
      : `
justify-content: flex-start;
`}
    ${({ isAdmin }) =>
    isAdmin
      ? `
${WrapperS} {
  background: ${RGBA_COLORS.getAccent(1)};

   * {
     color: #ffffff;
   } 
}
`
      : ``}
    ${({ isLector }) =>
    isLector
      ? `
    ${WrapperS} {
      background: #7DB945;

      * {
        color: #ffffff;
      } 
    }
`
      : ``};
`;
